import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/glide-g': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M407.1 211.2C403.6 209.8 395.5 207.4 391.7 207.4 354.6 207.4 329.5 224.2 298.2 241.9L297.3 241C304.3 193.7 320.8 149.1 320.8 100.6 320.8 29.1 282.6 0 212.4 0 97.3 0 39 113.7 39 198.4 39 286.3 90.3 335 177.6 335 189.6 335 188.6 334 188.6 338.8 171.7 467.7 97.8 471.9 97.8 433.4 97.8 394.2 142.8 374.8 143.3 372.4 143 360.2 96.3 344.8 84.4 344.8 50.5 344.9 32 396 32 424.1 32 476 64.8 512 117.5 512 194.9 512 251.5 434.2 268.9 366.6 284 306.1 280.1 303.3 288.6 299 320.8 282.8 346.1 272 382.4 272 400.2 272 412.9 275.7 441.3 280.4 444.2 280.4 448 277.5 448 274.6 448 266.6 414.6 214.1 407.1 211.2zM231.8 126.8C222.5 171.5 213.2 216.4 204 261.1 201.7 271.3 190.7 268.9 182 268.9 143.7 268.9 133 227.1 133 195.8 133 148.8 151 86.5 194.8 62.4 201.8 58.3 209.6 55.7 217.4 55.7 236 55.7 237.4 69 237.4 84.4 237.3 98.7 234.7 112.9 231.8 126.8z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/glide-g.js
// module id = TrNK
// module chunks = 144